import { motion } from "framer-motion";
import { GiLotus } from "react-icons/gi";

export default function BrandLoader({ 
  message = "Loading...", 
  subMessage = "Please wait a moment",
  minHeight = "min-h-[75vh]",
  isFullScreen = false,
  size = 48 
}) {
  return (
    <div 
      className={`relative flex flex-col items-center justify-center text-center p-6 select-none ${
        isFullScreen ? "min-h-screen bg-[#FFF8EE]" : minHeight
      }`} 
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Ambient background glow */}
      <div className="absolute pointer-events-none w-[300px] h-[300px] rounded-full bg-gradient-to-tr from-[#F29A0C]/15 to-[#E97818]/10 blur-3xl -z-10" />

      {/* Rotating Lotus Icon with subtle pulsing ring */}
      <div className="relative mb-5 flex items-center justify-center">
        {/* Soft pulsing outer halo */}
        <motion.div 
          animate={{ scale: [1, 1.22, 1], opacity: [0.25, 0.55, 0.25] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
          className="absolute w-20 h-20 rounded-full border border-[#F29A0C]/35 bg-[#F29A0C]/5"
        />
        {/* Secondary rotating dashed ring */}
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          className="absolute w-16 h-16 rounded-full border border-dashed border-[#F29A0C]/40"
        />
        {/* Spinning Lotus Icon */}
        <GiLotus 
          size={size} 
          className="text-[#E97818] animate-spin drop-shadow-[0_4px_14px_rgba(233,120,24,0.4)] relative z-10" 
        />
      </div>

      {/* Animated Text */}
      <h3 className="text-[15px] font-extrabold text-zinc-800 tracking-tight mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>
        {message}
      </h3>
      {subMessage && (
        <p className="text-[12px] font-semibold text-zinc-400">
          {subMessage}
        </p>
      )}
    </div>
  );
}